import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  enterAccountName: {
    id: 'enterAccountName',
    defaultMessage: 'Please enter your company name',
  },
  createCompany: {
    id: 'createCompany',
    defaultMessage: 'Create your corporate account',
  },
  createInfo: {
    id: 'createInfo',
    defaultMessage: 'Hey, you have been logged in as ',
  },
});

export default { ...globalIntl, ...m };
